import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { MessagesSquare, BarChart3, LogOut } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

const NAV = [
  { to: '/chatbot',   Icon: MessagesSquare, label: 'Chatbot',   desc: 'Conversaciones' },
  { to: '/dashboard', Icon: BarChart3,       label: 'Dashboard', desc: 'Estadísticas'   },
]

export default function Sidebar({ userName }) {
  const { logout } = useAuth()
  const navigate   = useNavigate()

  async function handleLogout() {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <aside style={{
      display: 'flex', flexDirection: 'column', height: '100vh',
      width: 248, flexShrink: 0,
      background: 'rgba(14,19,24,.8)',
      borderRight: '1px solid rgba(30,38,48,.7)',
      padding: '20px 16px',
    }}>
      {/* Logo */}
      <NavLink to="/chatbot" style={{ display: 'block', marginBottom: 32, padding: '0 4px' }}>
        <img src="/logo.png" alt="Centro de Arbitraje CCIA"
          style={{ width: 180, height: 'auto' }} />
      </NavLink>

      {/* Nav */}
      <nav style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {NAV.map(({ to, Icon, label, desc }) => (
          <NavLink key={to} to={to} style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 12,
            padding: '10px 12px', borderRadius: 8,
            textDecoration: 'none', transition: 'all .15s',
            background: isActive ? 'rgba(46,150,171,.12)' : 'transparent',
            outline: isActive ? '1px solid rgba(46,150,171,.25)' : 'none',
          })}
            onMouseEnter={e => { if (!e.currentTarget.classList.contains('active')) e.currentTarget.style.background = 'rgba(30,38,48,.5)' }}
            onMouseLeave={e => { if (!e.currentTarget.getAttribute('aria-current')) e.currentTarget.style.background = 'transparent' }}>
            {({ isActive }) => (
              <>
                <Icon size={19} style={{ color: isActive ? 'var(--teal-l)' : 'var(--ash-500)', flexShrink: 0 }} />
                <span>
                  <span style={{ display: 'block', fontSize: 14, fontWeight: 500, color: isActive ? '#fff' : 'var(--ash-300)' }}>
                    {label}
                  </span>
                  <span style={{ display: 'block', fontSize: 11, color: 'var(--ash-600)' }}>{desc}</span>
                </span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Footer — sesión */}
      <div style={{ marginTop: 'auto', borderTop: '1px solid rgba(30,38,48,.7)', paddingTop: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div style={{ padding: '0 4px' }}>
          <p style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: '.06em', color: 'var(--ash-600)' }}>Sesión</p>
          <p style={{ fontSize: 13, fontWeight: 500, color: 'var(--ash-300)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {userName}
          </p>
        </div>
        <button onClick={handleLogout} className="btn btn-ghost" style={{ width: '100%', fontSize: 13 }}>
          <LogOut size={15} /> Cerrar sesión
        </button>
      </div>
    </aside>
  )
}
